/* Niva V3 — hero plan ızgarası. Hero'daki rozeti yönlendirmeli bir alana dönüştürür. */
(function(){
  var GUNLER = ['PZT','SAL','ÇAR','PER','CUM','CMT','PAZ'];
  var DESEN = {'2':[0,3], '3':[0,2,4]};
  var dar = window.matchMedia('(max-width:760px)');

  function kur(){
    var panel = document.querySelector('.campaign-stamp');
    if(!panel || panel.dataset.v3) return;
    panel.dataset.v3 = '1';
    panel.className = 'plan-peek';
    panel.innerHTML =
      '<div class="plan-peek-head"><strong>Planına bak</strong><span>örnek 4 hafta</span></div>' +
      '<fieldset><legend>Günlük süre</legend><div class="plan-chips" data-grup="sure">' +
        '<button type="button" value="10">10 dk</button>' +
        '<button type="button" value="15">15 dk</button>' +
        '<button type="button" value="20">20 dk</button>' +
      '</div></fieldset>' +
      '<fieldset><legend>Haftada kaç gün</legend><div class="plan-chips" data-grup="gun">' +
        '<button type="button" value="2">2 gün</button>' +
        '<button type="button" value="3">3 gün</button>' +
      '</div></fieldset>' +
      '<div class="plan-weeks" role="img"></div>' +
      '<p class="plan-peek-foot" aria-live="polite"></p>';

    var durum = {sure:'15', gun:'3'};
    var hero = panel.closest('.campaign-hero');

    function yerlestir(){
      if(!hero || !hero.parentNode) return;
      panel.classList.add('is-flow');
      if(panel.parentNode !== hero.parentNode) hero.parentNode.insertBefore(panel, hero.nextSibling);
    }

    function ciz(){
      var gunler = DESEN[durum.gun];
      var izgara = panel.querySelector('.plan-weeks');
      var html = '';
      for(var h = 1; h <= 4; h++){
        html += '<span class="plan-week"><b>H' + h + '</b>';
        for(var g = 0; g < 7; g++){
          html += '<i' + (gunler.indexOf(g) > -1 ? ' class="on"' : '') + '></i>';
        }
        html += '</span>';
      }
      izgara.innerHTML = html;
      var adlar = gunler.map(function(g){ return GUNLER[g]; }).join(', ');
      izgara.setAttribute('aria-label',
        '4 haftalık örnek takvim: haftada ' + durum.gun + ' gün (' + adlar + '), günde ' + durum.sure + ' dakika.');
      panel.querySelector('.plan-peek-foot').innerHTML =
        '<b>' + adlar + '</b> · günde ' + durum.sure + ' dk. Örnek takvim; program satın alındıktan sonra yanıtlarına göre hazırlanır.';
      ['sure','gun'].forEach(function(ad){
        panel.querySelectorAll('[data-grup="' + ad + '"] button').forEach(function(b){
          b.setAttribute('aria-pressed', String(b.value === durum[ad]));
        });
      });
    }

    panel.addEventListener('click', function(e){
      var b = e.target.closest('.plan-chips button');
      if(!b) return;
      durum[b.parentNode.dataset.grup] = b.value;
      ciz();
    });

    dar.addEventListener('change', yerlestir);
    yerlestir();
    ciz();
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', kur);
  } else {
    kur();
  }
})();
